export const capitalize = (val) => {
  if (!val.trim()) return "";
  return (
    String(val)
      .charAt(0)
      .toUpperCase() + String(val).slice(1)
  );
};
